const deliveryReasons = [
    { value: 'DELIVERY_PRIMARY_MISSING_ORDER', text: 'Delivery Issue' },
    { value: 'DELIVERY_PRIMARY_QUALITY_ARRIVED_DAMAGED', text: 'Quality - Arrived Damaged' },
    { value: 'DELIVERY_PRIMARY_UNWANTED_ORDER', text: 'Unwanted Order' },
    { value: 'DELIVERY_PRIMARY_SHORTS', text: 'Shorts' },
    { value: 'DELIVERY_PRIMARY_OTHER', text: 'Other' },
];

const deliveryReasonsSecondaryMissingOrder = [
    {
        value: 'DELIVERY_SECONDARY_MISSING_ORDER_BOX_DELIVERED_TO_WRONG_ADDRESS',
        text: 'Box Delivered To Wrong Address',
    },
    {
        value: 'DELIVERY_SECONDARY_MISSING_ORDER_BOX_NOT_RECEIVED_CUST_FAULT_OR_STOLEN',
        text: 'Box Not Received: Cust. Fault or Stolen',
    },
    {
        value: 'DELIVERY_SECONDARY_MISSING_ORDER_CANT_LOCATE_BOX_NO_OR_POOR_PHOTO',
        text: "Can't Locate Box (No or Poor Photo)",
    },
    {
        value: 'DELIVERY_SECONDARY_MISSING_ORDER_DAMAGED_IN_TRANSIT_DISCARDED_BY_CARRIER',
        text: 'Damaged',
    },
    { value: 'DELIVERY_SECONDARY_MISSING_ORDER_DELIVERY_FAILED', text: 'Delivery Failed' },
    { value: 'DELIVERY_SECONDARY_MISSING_ORDER_DIDNT_LEAVE_WAREHOUSE', text: "Didn't Leave Warehouse" },
    {
        value: 'DELIVERY_SECONDARY_UNWANTED_ORDER_TECHNICAL_ISSUES_SYSTEM_ERROR',
        text: 'Technical Error',
    },
    {
        value: 'DELIVERY_SECONDARY_MISSING_ORDER_INSTRUCTIONS_NOT_FOLLOWED_BOX_NOT_RECEIVED',
        text: 'Instructions Not Followed Box Not Received',
    },
    { value: 'DELIVERY_SECONDARY_MISSING_ORDER_NOT_SCANNED_IN_BY_CARRIER', text: 'Not Scanned In By Carrier' },
    { value: 'DELIVERY_SECONDARY_WRONG_ORDER', text: 'Wrong Box Delivered To Customer' },
];

const deliveryReasonsSecondaryQuality = [
    { value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_BOX_ARRIVED_OPEN', text: 'Box Arrived Open' },
    { value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_BROKEN_GLASS', text: 'Broken Glass' },
    { value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_FROZEN', text: 'Frozen' },
    { value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_ICE_PACK_BROKEN', text: 'Ice Pack Broken' },
    {
        value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_INSULATION_PACKAGING_PROBLEM',
        text: 'Insulation/Packaging Problem',
    },
    {
        value: 'DELIVERY_SECONDARY_QUALITY_PRODUCT_QUALITY_ISSUE', // NEW!
        text: 'Product Quality',
    },
    {
        value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_PRODUCT_SPILL_BROKEN_GROCERY_PACKAGING',
        text: 'Product Spill/Broken Grocery Packaging',
    },
    { value: 'DELIVERY_SECONDARY_QUALITY_ARRIVED_DAMAGED_TOO_LONG_IN_TRANSIT', text: 'Too Long In Transit' },
];

const deliveryReasonsSecondaryUnwantedOrder = [
    { value: 'DELIVERY_SECONDARY_UNWANTED_ORDER_PAST_CANCEL_CUTOFF', text: 'Late Cancel' },
];

const deliveryReasonsSecondaryShorts = [
    { value: 'DELIVERY_SECONDARY_SHORTS_TOO_MANY_SHORTS', text: 'Too Many Shorts' },
];

const productReasons = [
    { value: 'PRODUCT_PRIMARY_MISSING', text: 'Missing' },
    { value: 'PRODUCT_PRIMARY_DAMAGED', text: 'Damaged' },
    { value: 'PRODUCT_PRIMARY_PACKAGING_ISSUE', text: 'Packaging Issue' },
    { value: 'PRODUCT_PRIMARY_ROTTEN_SPOILED', text: 'Rotten or Spoiled' },
    { value: 'PRODUCT_PRIMARY_UNHAPPY_WITH_ITEM', text: 'Unhappy with Item' },
    { value: 'PRODUCT_PRIMARY_UNWANTED_ITEM', text: 'Unwanted Item' },
    { value: 'PRODUCT_PRIMARY_FOOD_SAFETY', text: 'Food Safety' },
    // { value: 'PRODUCT_PRIMARY_OTHER', text: 'Other' }, // CC wanted it removed
];

const productReasonsSecondaryMissing = [
    { value: 'PRODUCT_SECONDARY_MISSING_ITEM', text: 'Missing Item' },
    { value: 'PRODUCT_SECONDARY_MISSING_UNDER_COUNT', text: 'Under Count' },
];

const productReasonsSecondaryDamaged = [
    { value: 'PRODUCT_SECONDARY_DAMAGED_BROKEN_BRUISED', text: 'Broken / Bruised' }, // ALSO PRODUCT_SECONDARY_DAMAGED_BRUISED
    { value: 'PRODUCT_SECONDARY_DAMAGED_DAMAGED_BY_ANOTHER_PRODUCT', text: 'Damaged By Another Product' },
];

const productReasonsSecondaryPackagingIssue = [
    { value: 'PRODUCT_SECONDARY_PACKAGING_FROZEN_DUE_TO_WEATHER', text: 'Frozen - Due to Weather' },
    { value: 'PRODUCT_SECONDARY_PACKAGING_HEAT_DAMAGE_DUE_TO_WEATHER', text: 'Heat Damage - Due to Weather' },
    { value: 'PRODUCT_SECONDARY_PACKAGING_HEAT_DAMAGE_PACKAGING_GENERAL', text: 'Heat Damage - Packaging' }, // NEW!
    { value: 'PRODUCT_SECONDARY_PACKAGING_ICE_PACK_BROKEN', text: 'Ice Pack Damage' },
];

const productReasonsSecondaryRottenOrSpoiled = [
    { value: 'PRODUCT_SECONDARY_ROTTEN_SPOILED_BUGS_PESTS', text: 'Bugs / Pests' },
    { value: 'PRODUCT_SECONDARY_ROTTEN_SPOILED_EXPIRED_PRODUCT', text: 'Expired Product' },
    { value: 'PRODUCT_SECONDARY_ROTTEN_SPOILED_MOLDY_UPON_DELIVERY', text: 'Moldy / Rotten Upon Delivery' },
    { value: 'PRODUCT_SECONDARY_UNHAPPY_WITH_ITEM_SHORT_SHELF_LIFE', text: 'Short Shelf Life' },
];

const productReasonsSecondaryUnhappyWithItem = [
    { value: 'PRODUCT_SECONDARY_UNHAPPY_WITH_ITEM_POOR_TASTE_QUALITY', text: 'Personal Preference' },
    { value: 'PRODUCT_SECONDARY_UNWANTED_ITEM_PRODUCT_NOT_AS_DESCRIBED', text: 'Product Not as Described' },
    { value: 'PRODUCT_SECONDARY_UNHAPPY_WITH_ITEM_PORTION_SIZE', text: 'Unhappy with Size or Weight' },
];

const productReasonsSecondaryUnwantedItem = [
    {
        value: 'PRODUCT_SECONDARY_UNWANTED_ITEM_ALWAYS_LIST_OR_ADD_ON_COMPLAINT',
        text: 'Seeding / Recurring Item Issue',
    },
    { value: 'PRODUCT_SECONDARY_UNWANTED_ITEM_FORGOT_TO_CUSTOMIZE', text: 'Forgot to Customize' },
];

const productReasonsSecondaryFoodSafety = [
    { value: 'PRODUCT_SECONDARY_FOOD_SAFETY_FOOD_POISONING', text: 'Food Poisoning' },
    { value: 'PRODUCT_SECONDARY_FOOD_SAFETY_FOREIGN_OBJECT_IN_BOX', text: 'Foreign Object in Box' },
    { value: 'PRODUCT_SECONDARY_FOOD_SAFETY_PRODUCT_RECALL', text: 'Product Recall' },
];

const deliveryReasonsMap = {
    DELIVERY_PRIMARY_MISSING_ORDER: deliveryReasonsSecondaryMissingOrder,
    DELIVERY_PRIMARY_QUALITY_ARRIVED_DAMAGED: deliveryReasonsSecondaryQuality,
    DELIVERY_PRIMARY_UNWANTED_ORDER: deliveryReasonsSecondaryUnwantedOrder,
    DELIVERY_PRIMARY_SHORTS: deliveryReasonsSecondaryShorts,
    DELIVERY_PRIMARY_OTHER: [],
};

const productReasonsMap = {
    PRODUCT_PRIMARY_MISSING: productReasonsSecondaryMissing,
    PRODUCT_PRIMARY_DAMAGED: productReasonsSecondaryDamaged,
    PRODUCT_PRIMARY_PACKAGING_ISSUE: productReasonsSecondaryPackagingIssue,
    PRODUCT_PRIMARY_ROTTEN_SPOILED: productReasonsSecondaryRottenOrSpoiled,
    PRODUCT_PRIMARY_UNHAPPY_WITH_ITEM: productReasonsSecondaryUnhappyWithItem,
    PRODUCT_PRIMARY_UNWANTED_ITEM: productReasonsSecondaryUnwantedItem,
    PRODUCT_PRIMARY_FOOD_SAFETY: productReasonsSecondaryFoodSafety,
    PRODUCT_PRIMARY_OTHER: [],
};

export { deliveryReasons, deliveryReasonsMap, productReasons, productReasonsMap };
